import * as React from 'react'
import { flatMap } from 'lodash'

import { Checkbox, Spinner } from '@/components/ui'
import { useCompanyInfinite } from '@/features/company/hooks'

import { useInfinityLoadMore } from '../../hooks/useInfinityLoadMore'

const OrgAdminAccess = () => {
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    useCompanyInfinite()

  const { scrollContainerRef, loadMoreRef } = useInfinityLoadMore({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  })

  const companies = React.useMemo(() => {
    return flatMap(data?.pages, (page) => page?.data) || []
  }, [data])

  return (
    <div className="flex flex-col gap-3 max-h-120">
      <span className="text-md text-primary-900">
        Organization Admins have access to all companies listed below.
      </span>
      <div
        ref={scrollContainerRef}
        className="overflow-y-auto overflow-x-hidden"
      >
        <div className="relative h-fit space-y-0.5">
          {isLoading ? (
            <div className="flex items-center justify-center py-2 h-40">
              <Spinner className="size-4 text-brand-600" />
            </div>
          ) : (
            companies.map((company) => (
              <div key={company.id} className="py-2 px-2.5">
                <Checkbox
                  checked
                  label={company.name}
                  checkBoxClassName="!bg-gray-400 !border-transparent"
                  labelClassName="text-sm font-medium text-primary-900"
                />
              </div>
            ))
          )}
          {isFetchingNextPage ? (
            <div className="flex items-center justify-center py-2">
              <Spinner className="size-4 text-brand-600" />
            </div>
          ) : null}
          <div ref={loadMoreRef} className="absolute bottom-20 w-full h-10" />
        </div>
      </div>
    </div>
  )
}

const MemoizedOrgAdminAccess = React.memo(OrgAdminAccess)
MemoizedOrgAdminAccess.displayName = 'OrgAdminAccess'

export { MemoizedOrgAdminAccess as OrgAdminAccess }
